<template>
<div class="container mt-5">
  <b-button @click="$router.go(-1)" class="btn-sm btn-danger me-3"><i class='mdi mdi-arrow-left'></i> Go Back</b-button>
   <b-button type="button" class="btn btn-sm btn-success" @click="printPDF"><i class="mdi mdi-file-pdf"></i> Save</b-button>

   <div class="mt-3 shadow-lg rounded-3" id="print-section" v-for="item in bookings" :key="item.id">
      <div class="row">
          <div class="col-1">
              <barcode :value="item.order_id" height="50" display-value="false" style="transform: rotate(90deg); "></barcode>
          </div>
          <div class="col-2 py-4 px-0 m-0">
              <h6 class="mb-0">Client Details :</h6>
              <span style="color:black;font-size:16px"><b class="text-uppercase"> {{ item.client.business_name }}</b></span><br>
              <span style="color:black;font-size:13px"> Location : {{ item.client.business_address }}</span><br>
              <span style="color:black;font-size:13px"> Telephone : {{ item.client.business_contact }}</span><br><br><br>
              
              <img src="@/assets/images/logo.png" alt height="50" style="border-radius: 5%;"/>
          </div>
          <div class="col-2 py-4 px-0 m-0">
              <h6 class="mb-0">Vendor Details :</h6>
              <span style="color:black;font-size:16px"><b class="text-uppercase"> {{ item.vendor.business_name }}</b></span><br>
              <span style="color:black;font-size:13px"> <i class="mdi mdi-map-marker"></i> : {{ item.vendor.business_address }}</span><br>
              <span style="color:black;font-size:13px"> <i class="mdi mdi-phone"></i> : {{ item.vendor.business_contact }}</span><br>
          </div>
          <div class="col-4 px-0 py-4 m-0">
              <h6 class="mb-0">Paid For :</h6>
              <b style="color:black;font-size:16px" class="text-uppercase"> {{ item.product.name }}</b><br>
              <span style="color:black;font-size:13px"> Price : {{ commas(Number(item.product.price)*Number(item.quantity)) }}</span><br>
                In Words : <span class="text-capitalize">{{ moneyToWords(Number(item.product.price)*Number(item.quantity)) }}</span><br>
              <span style="color:black;font-size:13px"> Paid : {{ item.added_at }}</span><br>
          </div>
          <div class="col-3 py-3 px-0 mx-0 my-auto bg-primary">
              <center><qr-code :text="item.order_id" bg-color="#564ab1" :size="120" error-level="L"></qr-code><br><br><br>
              <u style="color:white;font-size:13px"> www.ovvura.ae </u></center>
          </div>
      </div>
   </div>
</div>
</template>

<script>
import appConfig from "@/app.config";
import axios from "axios";
import html2pdf from 'html2pdf.js';
import VueBarcode from 'vue-barcode';
export default {
  page: {
    title: "Print",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    'barcode': VueBarcode
  },
  data() {
      return {
          userData: JSON.parse(localStorage.getItem("user")),
          bookings:[],
      };
  },
  methods: {
      async showbooking(){
          this.transaction_id=this.$route.query.id;
          let url = `/bookingbyid/${this.transaction_id}`;
          await axios.get(url).then((response) => {
          this.bookings = response.data.bookings;
        //   setTimeout(() => { window.print(); window.onafterprint=this.$router.go(-1);}, 1000);
          });
      },
      getFiles(name){
          let url = axios.defaults.baseURL;
          let imagelink = (url).slice(0,-3)+"logos/"+name;
          return imagelink;
      },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    printPDF() {
      const element = document.getElementById('print-section');
      const options = { filename: 'Kwiika Ticket.pdf',image: { type: 'png', quality: 0.98 },html2canvas:  { scale: 2 }, jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }};
      html2pdf().from(element).set(options).save();
    },
    moneyToWords(value) {
      const toWords = (num) => {
      const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
      const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
      const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
      const convert = (num) => {
      if (num < 10) return ones[num];
      if (num < 20) return teens[num - 11];
      if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : '');
      if (num < 1000) return ones[Math.floor(num / 100)] + ' hundred' + (num % 100 !== 0 ? ' and ' + convert(num % 100) : '');
      if (num < 1000000) return convert(Math.floor(num / 1000)) + ' thousand' + (num % 1000 !== 0 ? ' ' + convert(num % 1000) : '');
      if (num < 1000000000) return convert(Math.floor(num / 1000000)) + ' million' + (num % 1000000 !== 0 ? ' ' + convert(num % 1000000) : '');
      };
      if (num === 0) return 'zero';
      return convert(num);
  };
  return toWords(value);
  },
  },
  created() {
      this.showbooking();
  },
}
</script>
<!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js" integrity="sha512-GsLlZN/3F2ErC5ifS5QtgpiJtWd43JWSuIgh7mbzZ8zBps+dvLusV+eNQATqgA/HdeKFVgA5v3S/cIrLF7QnIg==" crossorigin="anonymous" referrerpolicy="no-referrer"></script> -->